import { useState, useEffect } from 'react';

export interface IWindowSize {
  width: number;
  height: number;
  orientation: number;
}

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<IWindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
    orientation: window.screen.orientation.angle
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        orientation: window.screen.orientation.angle
      });
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  return {
    ...windowSize,
  };
}

export default useWindowSize;
